import React, { Component } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { Field, Errors } from 'react-redux-form';
import classnames from 'classnames';

class Checkbox extends Component {
    render() {
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--error': !this.props.valid && this.props.touched,
            'form__row--disabled': this.props.disabled
        });

        let renderCheckbox = this.props.options.map((opt, index) => {
            return (
                <div key={index} className="form__item form__item--checkbox">
                    <label className="form__label">
                        <input
                            type="checkbox"
                            className="form__checkbox"
                            id={opt.id}
                            value={opt.value ? opt.value : opt.code}
                            onClick={this.props.onClick}
                        />
                        <span className="form__title">{opt.name}</span>
                    </label>
                </div>
            );
        });

        return (
            <div className={formRowClassNames}>
                <Field
                    model={this.props.model}
                    validators={this.props.validators}
                    onChange={this.props.onChange}
                >
                    <div className="form__row-title">
                        {this.props.title}
                        {this.props.isRequired ? (
                            <span className="form__required">*</span>
                        ) : (
                            ''
                        )}
                    </div>
                    {renderCheckbox}
                </Field>
                <Errors
                    wrapper={props => (
                        <div className="form__error-messages">
                            {props.children}
                        </div>
                    )}
                    className="errors"
                    model={this.props.model}
                    show="touched"
                    messages={this.props.messages}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, { model }) => ({
    valid: get(state.forms, `${model}.valid`, false),
    touched: get(state.forms, `${model}[.touched`, false)
});

export default connect(mapStateToProps)(Checkbox);



// WEBPACK FOOTER //
// ./src/components/ui/checkbox.js